var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_10367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2778 11.3889V9.16667H11.3889V4.72222H9.16667V9.16667H4.72222V11.3889H9.16667V20.2778H11.3889V11.3889H20.2778ZM20.2778 2.5C20.8333 2.5 21.3889 2.72222 21.8222 3.17778C22.2778 3.61111 22.5 4.16667 22.5 4.72222V20.2778C22.5 20.8333 22.2778 21.3889 21.8222 21.8222C21.3889 22.2778 20.8333 22.5 20.2778 22.5H4.72222C4.16667 22.5 3.61111 22.2778 3.17778 21.8222C2.72222 21.3889 2.5 20.8333 2.5 20.2778V4.72222C2.5 4.16667 2.72222 3.61111 3.17778 3.17778C3.61111 2.72222 4.16667 2.5 4.72222 2.5H20.2778Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_10367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSheet);
export default __webpack_public_path__ + "static/media/ico-sheet.51e61dd03a4223eb9642ec76f1ff72e4.svg";
export { ForwardRef as ReactComponent };